import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation from react-router-dom
import CountUp from 'react-countup';

const StatsSection = () => {
  const [inView, setInView] = useState(false);
  const location = useLocation(); // Get current page location

  // Data for the statistics
  const statsData = [
    { label: 'Years of Expertise', end: 5, suffix: '+' },
    { label: 'Projects Delivered', end: 468, suffix: '+' },
    { label: 'Highly Skilled Professionals', end: 37, suffix: '+' },
    { label: 'E-commerce Solutions Delivered', end: 156, suffix: '+' }
  ];

  useEffect(() => {
    // Intersection Observer to detect when the section is in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setInView(true); // Trigger count-up when section is in view
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    const element = document.getElementById('statsSection');
    observer.observe(element);

    return () => observer.disconnect(); // Cleanup observer when component unmounts
  }, []);

  // Check if the current page is Home
  const isHomePage = location.pathname === '/';

  return (
    <div id="statsSection" className="bg-transparent">
      <div className={`relative mx-auto  ${isHomePage ? 'lg:px-8 sm:px-6  px-2' : 'py-4'}`}>
        <div className="max-w-7xl mx-auto">
          {/* Conditional grid layout based on the page */}
          <div
            className={`grid ${isHomePage ? 'grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2 md:gap-6' : 'grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-2 md:gap-4'}`}
          >
            {statsData.map((stat, index) => (
              <div
                key={index}
                className={`flex flex-col text-center [transition:all_400ms_ease] hover:shadow-2xl hover:shadow-gray-900 hover:-translate-y-[1rem] hover:text-gray-300
                  ${isHomePage ? 'p-6 rounded-lg shadow-lg border border-gray-100' : 'p-0 rounded-lg shadow-2xl shadow-gray-400 border border-gray-100'}
                  ${!isHomePage && index < 3 ? 'border-r py-4 px-2' : 'border-r py-4 px-2'}`} // Apply border-r for the first 3 items on non-home page
              >
                <dt className={`order-2 mt-2 font-medium leading-6 text-gray-500
                  ${isHomePage ? 'lg:text-lg text-sm' : 'lg:text-lg text-md'}`}
                >
                  {stat.label}
                </dt>
                <dd className={`order-1 font-extrabold leading-none text-[#1353FE]
                  ${isHomePage ? 'lg:text-5xl text-3xl' : 'lg:text-5xl text-3xl'}`}
                >
                  {inView && <CountUp end={stat.end} duration={3} separator="," suffix={stat.suffix} />}
                </dd>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
